import { render, staticRenderFns } from "./ConvoComment.vue?vue&type=template&id=2c542ece&"
import script from "./ConvoComment.vue?vue&type=script&lang=js&"
export * from "./ConvoComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports